import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../../../../Helper/Context";

export default function GardenMaintainanceCard({ title, imgcss, cardName, navLink, imgPath, imgPathw, Active, Pathname, GardenMaintainanceNavigate }) {

    const userDetails = useAuthState();
    const { M_ProjectTypeID, RoleID } = userDetails.user

    const navigate = useNavigate()

    // const handleGardenMaintainanceCardClick = () => {
    //     navigate(navLink)
    // }

    return (
        // <div className={cardName} onClick={handleGardenMaintainanceCardClick}>
        <div className={cardName}
            onClick={(e) => (RoleID == 3 && M_ProjectTypeID == 5) ? e.preventDefault() : GardenMaintainanceNavigate(title)}
            style={{ cursor: (RoleID == 3 && M_ProjectTypeID == 5) ? "not-allowed" : "pointer" }}
        >
            <div className={Active}>

                <img className="pt-1 " style={{ width: "31px" }}
                    src={imgPath}
                    rel="preload"
                    alt="img"
                // src={require(imgPath)}
                />
                <span className=" pt-1 pb-0 text-center"><b>{title}</b></span>
            </div>
        </div>
    )
}